import React from 'react';

import { permissions } from '@vlabs/shared/config';
import { useModal } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { ButtonWithPermissions } from '@vlabs/monokit/shared/ui/button-with-permissions';
import type { ButtonWithPermissionsProps } from '@vlabs/monokit/shared/ui/button-with-permissions';

import { PackageImportFeature } from './PackageImportFeature';

interface PackageImportButtonProps extends Omit<ButtonWithPermissionsProps, 'permissions' | 'onClick'> {
  onPackageImport?: VoidFunction;
}

function PackageImportButton({
  onPackageImport = undefined,
  ...props
}: PackageImportButtonProps): React.JSX.Element {
  const { t } = useTranslation();
  const packageImportModal = useModal();

  const handlePackageImport = () => {
    packageImportModal.close();
    if (onPackageImport) onPackageImport();
  };

  return (
    <React.Fragment>
      {packageImportModal.wrap(<PackageImportFeature onPackageImport={handlePackageImport} />)}

      <ButtonWithPermissions
        data-testid="packageImportButton"
        onClick={() => packageImportModal.open()}
        permissions={{ rules: [permissions.task.creation] }}
        {...props}
      >
        {props?.children ?? t('features:packageImport.package_import_button.label')}
      </ButtonWithPermissions>
    </React.Fragment>
  );
}

export { PackageImportButton };
